import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import searchTour from 'entities/tour/models/search-tour/search-tour'
import tourListStore from 'entities/tour/models/tour-list/tour-list'
import { SearchFormTours } from 'entities/tour/ui/search-form-tours'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const TourSearchFormPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const dataForSearchTour = searchTour.getEditableDataForSearchTour()

  const handleSearch = () => {
    searchTour.commitSearchEdit()
    tourListStore.resetTourList()
    navigate(-1)
  }

  useEffect(() => {
    if (!searchTour.getIsSearchEditing()) {
      navigate(RoutingPaths.tours.path(), { replace: true })
    }
  }, [navigate])

  return (
    <div className={s.container}>
      <HeaderGoBack
        variant="grey"
        title={t('edit_search')}
        onGoBack={() => navigate(-1)}
      />

      <div className={s.form}>
        <SearchFormTours
          dataForSearchTour={dataForSearchTour}
          onSearch={handleSearch}
        />
      </div>
    </div>
  )
})

export default TourSearchFormPage
